// Uploaded background images are served at .../location/background/<filename>, with a
// same-directory thumbnail stored as .../location/background/thumb_<filename>. Pasted
// external URLs never match this path, so they fall back to being rendered at full size.
const SERVE_PATH_MARKER = "/location/background/";
const THUMBNAIL_PREFIX = "thumb_";

export function getThumbnailUrl(fullUrl) {
  if (!fullUrl) {
    return null;
  }

  const markerIndex = fullUrl.indexOf(SERVE_PATH_MARKER);
  if (markerIndex === -1) {
    return null;
  }

  const prefix = fullUrl.substring(0, markerIndex + SERVE_PATH_MARKER.length);
  const filename = fullUrl.substring(markerIndex + SERVE_PATH_MARKER.length);
  if (!filename || filename.startsWith(THUMBNAIL_PREFIX)) {
    return fullUrl;
  }

  return `${prefix}${THUMBNAIL_PREFIX}${filename}`;
}
